import BaseComponent from './BaseComponent';

export default class HideInputField extends BaseComponent {
    constructor() {
        super();

        this._inputFields = null;

        this.init();
    }

    init() {
        this._inputFields = Array.from(document.querySelectorAll('.blb-input.hidden-input'));

        this._inputFields.forEach((field) => {
            this._hideField(field);
        });
    }

    _hideField(element) {
        element.setAttribute('type', 'hidden');
    }
}